"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var Localize_1 = require("../../../gen-src/Localize");
var globalTypes_1 = require("../../../gen-src/queries/globalTypes");
var DatabaseNameCell_1 = require("../datagrid/cellFormatters/DatabaseNameCell");
var ObfuscatedCellFormatter_1 = require("../datagrid/cellFormatters/ObfuscatedCellFormatter");
var UserNameCell_1 = require("../datagrid/cellFormatters/UserNameCell");
var makeColumnFactoryParams_1 = require("../sorting/makeColumnFactoryParams");
var shouldBeObfuscated = function (_a) {
    var name = _a.name;
    return name === null;
};
function iconColumn(rowData, getHideCertificationWidgetFromRowData) {
    var hideCertWidgetOverride = getHideCertificationWidgetFromRowData ? getHideCertificationWidgetFromRowData(rowData) : false;
    if (rowData.__typename === 'DatabaseTable' && rowData.isCertified && !hideCertWidgetOverride) {
        return (React.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) {
            return React.createElement(data_catalog_shared_1.CertificationWidget, { icon: React.createElement(data_catalog_shared_1.TableMediumIcon, { isCertified: rowData.isCertified }), contentId: rowData.id, certification: rowData, siteUrls: urls, showExtractRefresh: false });
        }));
    }
    return React.createElement(data_catalog_shared_1.TableMediumIcon, { isCertified: false });
}
exports.columns = [
    function () { return ({
        name: 'warning',
        dataKey: '',
        headerText: '',
        headerTooltip: Localize_1.Messages.DataQualityWarningTitle(),
        headerFormatter: data_catalog_shared_1.DataQualityIconHeaderFormatterFactory,
        cellFormatter: data_catalog_shared_1.createDataQualityCellFormatter({
            getWarningsFromRowData: function (r) {
                if (r.__typename !== 'DatabaseTable') {
                    return [];
                }
                else {
                    return r.dataQualityWarnings;
                }
            },
            disableIconOnlyTabIndex: true,
        }),
        sortable: false,
        resizable: false
    }); },
    function (sortParams) { return ({
        name: 'type',
        dataKey: globalTypes_1.DatabaseTableOrderField.IS_CERTIFIED,
        headerText: Localize_1.Messages.GridHeaderType(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: data_catalog_shared_1.createIconCellFormatter(function (rowData) { return iconColumn(rowData); }, function (rowData) { return (rowData.__typename === 'DatabaseTable' && rowData.isCertified) ? '' : Localize_1.Messages.Table(); }),
        resizable: false,
        sortable: true,
    }); },
    function (params) { return ({
        name: 'name',
        dataKey: globalTypes_1.DatabaseTableOrderField.NAME,
        headerText: Localize_1.Messages.GridHeaderName(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(params),
        cellFormatter: ObfuscatedCellFormatter_1.createObfuscatedLinkCellFormatter(shouldBeObfuscated, function (_a) {
            var name = _a.name;
            return name;
        }, function (urls, _a) {
            var id = _a.id;
            return urls.catalogTablePath(id);
        }, undefined, // noPadding
        true // disableTabIndex
        ),
        growToFit: true,
        resizable: true,
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'workbooks',
        dataKey: globalTypes_1.DatabaseTableOrderField.DOWNSTREAM_WORKBOOKS_COUNT,
        headerText: Localize_1.Messages.GridHeaderWorkbooks(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: data_catalog_shared_1.createCountBarCellFormatter(function (_a) {
            var downstreamWorkbooksConnection = _a.downstreamWorkbooksConnection;
            return downstreamWorkbooksConnection ? downstreamWorkbooksConnection.totalCount : null;
        }, function (_a) {
            var maxDownstreamWorkbooks = _a.maxDownstreamWorkbooks;
            return maxDownstreamWorkbooks ? maxDownstreamWorkbooks : null;
        }),
        resizable: true,
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'datasources',
        dataKey: globalTypes_1.DatabaseTableOrderField.DOWNSTREAM_DATASOURCES_COUNT,
        headerText: Localize_1.Messages.GridHeaderDatasources(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: data_catalog_shared_1.createCountBarCellFormatter(function (_a) {
            var downstreamDatasourcesConnection = _a.downstreamDatasourcesConnection;
            return downstreamDatasourcesConnection ? downstreamDatasourcesConnection.totalCount : null;
        }, function (_a) {
            var maxDownstreamDatasources = _a.maxDownstreamDatasources;
            return maxDownstreamDatasources ? maxDownstreamDatasources : null;
        }),
        resizable: true,
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'database',
        dataKey: '',
        headerText: Localize_1.Messages.GridHeaderDatabaseNamePath(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: ObfuscatedCellFormatter_1.createObfuscatedTextWithIconCellFormatter(shouldBeObfuscated, DatabaseNameCell_1.getDatabaseDisplayString, DatabaseNameCell_1.tableDatabaseGroupIcon, DatabaseNameCell_1.tableDatabaseCellTitle),
        resizable: true,
        sortable: false,
    }); },
    function (sortParams) { return ({
        name: 'columns',
        dataKey: data_catalog_shared_1.UnsortableColumnKey,
        headerText: Localize_1.Messages.GridHeaderColumns(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: ObfuscatedCellFormatter_1.createObfuscatedNamesWithCountCellFormatter(shouldBeObfuscated, function (_a) {
            var columnsConnection = _a.columnsConnection;
            return columnsConnection ? columnsConnection.nodes.map(function (column) { return column.name || ''; }) : [];
        }, function (_a) {
            var columnsConnection = _a.columnsConnection;
            return columnsConnection ? columnsConnection.totalCount : 0;
        }),
        resizable: true,
        sortable: false,
    }); },
    function (sortParams) { return ({
        name: 'contact',
        dataKey: data_catalog_shared_1.UnsortableColumnKey,
        headerText: Localize_1.Messages.GridHeaderContact(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: UserNameCell_1.createUserNameLinkCellFormatter(function (rowData) { return rowData.__typename === 'DatabaseTable' ? rowData.contact : null; }, true),
        resizable: true,
        sortable: false,
    }); }
];
exports.columnsForCRASS = [
    function () { return ({
        name: 'warning',
        dataKey: '',
        headerText: '',
        headerTooltip: Localize_1.Messages.DataQualityWarningTitle(),
        headerFormatter: data_catalog_shared_1.DataQualityIconHeaderFormatterFactory,
        cellFormatter: data_catalog_shared_1.createDataQualityCellFormatter({
            getWarningsFromRowData: function (r) {
                if (r.__typename !== 'DatabaseTable' || r.id === '') {
                    return [];
                }
                else {
                    return r.dataQualityWarnings;
                }
            },
            disableIconOnlyTabIndex: true,
        }),
        sortable: false,
        resizable: false
    }); },
    function (sortParams) { return ({
        name: 'type',
        dataKey: globalTypes_1.DatabaseTableOrderField.IS_CERTIFIED,
        headerText: Localize_1.Messages.GridHeaderType(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: data_catalog_shared_1.createIconCellFormatter(function (rowData) { return iconColumn(rowData, function (r) { return r.id === ''; }); }, function (rowData) { return (rowData.__typename === 'DatabaseTable' && rowData.isCertified) ? '' : Localize_1.Messages.Table(); }),
        resizable: false,
        sortable: true,
    }); },
    function (params) { return ({
        name: 'name',
        dataKey: globalTypes_1.DatabaseTableOrderField.NAME,
        headerText: Localize_1.Messages.GridHeaderName(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(params),
        cellFormatter: ObfuscatedCellFormatter_1.createObfuscatedLinkCellFormatter(shouldBeObfuscated, function (_a) {
            var name = _a.name;
            return name;
        }, function (urls, _a) {
            var id = _a.id;
            return urls.catalogTablePath(id);
        }, undefined, // noPadding
        true, // disableTabIndex
        undefined, // ObfuscatedComponent
        function (rowData) { return rowData.id === ''; }),
        growToFit: true,
        resizable: true,
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'workbooks',
        dataKey: globalTypes_1.DatabaseTableOrderField.DOWNSTREAM_WORKBOOKS_COUNT,
        headerText: Localize_1.Messages.GridHeaderWorkbooks(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: data_catalog_shared_1.createCountBarCellFormatter(function (_a) {
            var downstreamWorkbooksConnection = _a.downstreamWorkbooksConnection;
            return downstreamWorkbooksConnection ? downstreamWorkbooksConnection.totalCount : null;
        }, function (_a) {
            var maxDownstreamWorkbooks = _a.maxDownstreamWorkbooks;
            return maxDownstreamWorkbooks ? maxDownstreamWorkbooks : null;
        }, undefined, // colorPaletteName
        function (rowData) { return rowData.id === ''; }),
        resizable: true,
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'datasources',
        dataKey: globalTypes_1.DatabaseTableOrderField.DOWNSTREAM_DATASOURCES_COUNT,
        headerText: Localize_1.Messages.GridHeaderDatasources(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: data_catalog_shared_1.createCountBarCellFormatter(function (_a) {
            var downstreamDatasourcesConnection = _a.downstreamDatasourcesConnection;
            return downstreamDatasourcesConnection ? downstreamDatasourcesConnection.totalCount : null;
        }, function (_a) {
            var maxDownstreamDatasources = _a.maxDownstreamDatasources;
            return maxDownstreamDatasources ? maxDownstreamDatasources : null;
        }, undefined, // colorPaletteName
        function (rowData) { return rowData.id === ''; }),
        resizable: true,
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'database',
        dataKey: '',
        headerText: Localize_1.Messages.GridHeaderDatabaseNamePath(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: ObfuscatedCellFormatter_1.createObfuscatedTextWithIconCellFormatter(shouldBeObfuscated, DatabaseNameCell_1.getDatabaseDisplayString, DatabaseNameCell_1.tableDatabaseGroupIcon, DatabaseNameCell_1.tableDatabaseCellTitle, undefined, // placeholder
        function (rowData) { return rowData.id === ''; }),
        resizable: true,
        sortable: false,
    }); },
    function (sortParams) { return ({
        name: 'columns',
        dataKey: data_catalog_shared_1.UnsortableColumnKey,
        headerText: Localize_1.Messages.GridHeaderColumns(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: ObfuscatedCellFormatter_1.createObfuscatedNamesWithCountCellFormatter(shouldBeObfuscated, function (_a) {
            var columnsConnection = _a.columnsConnection;
            return columnsConnection ? columnsConnection.nodes.map(function (column) { return column.name || ''; }) : [];
        }, function (_a) {
            var columnsConnection = _a.columnsConnection;
            return columnsConnection ? columnsConnection.totalCount : 0;
        }, undefined, // maxShown
        undefined, // ObfuscatedComponent
        function (rowData) { return rowData.id === ''; }),
        resizable: true,
        sortable: false,
    }); },
    function (sortParams) { return ({
        name: 'contact',
        dataKey: data_catalog_shared_1.UnsortableColumnKey,
        headerText: Localize_1.Messages.GridHeaderContact(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: UserNameCell_1.createUserNameLinkCellFormatter(function (rowData) { return rowData.__typename === 'DatabaseTable' ? rowData.contact : null; }, true, function (rowData) { return rowData.id === ''; }),
        resizable: true,
        sortable: false,
    }); }
];
exports.columnsForVizPortal = data_catalog_shared_1.mapDC3ColumnFactoriesToVizPortalColumnFactories(exports.columns, makeColumnFactoryParams_1.makeDC3ColumnFactoryParamsFromVizPortalParams);
exports.columnsWithCRASSForVizPortal = data_catalog_shared_1.mapDC3ColumnFactoriesToVizPortalColumnFactories(exports.columnsForCRASS, makeColumnFactoryParams_1.makeDC3ColumnFactoryParamsFromVizPortalParams);
function TablesDisplayGrid(props) {
    var cols = exports.columns.map(function (columnFactory) { return columnFactory(props); });
    return (React.createElement(data_catalog_shared_1.ExplorerStyledDisplayGrid, { columns: cols, rowStore: props.rowStore, emptyGridMessage: props.emptyGridMessage, rowCount: props.rowCount, renderErrors: data_catalog_shared_1.reportGraphQLErrors, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
}
exports.TablesDisplayGrid = TablesDisplayGrid;
//# sourceMappingURL=TablesDisplayGrid.js.map